import React, { createElement } from 'react';

import { TypographyType } from '@sleepunique/types/typography-type';

const Typography = ({ tag, text = '', className }: TypographyType) => {
  const tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'blockquote', 'q', 'strong'];
  const matchedTag = () => (tags.includes(tag) ? tag : 'p');

  return createElement(matchedTag(), { className }, text);
};

export default Typography;
